let timelineElements = [
    {
      id: 1,
      title: "League 1",
      description:
        "Manchester City secures promotion to the Second Division (now EFL Championship) under the management of Kevin Keegan.",
      date: " March 2002",
      icon: "work",
    },
    {
      id: 2,
      title: "Championship",
      
      description:
        "After a dramatic final day of the season, Manchester City secures a place in the Premier League for the first time since its formation in 1992.",

      date: "May 2008",
      icon: "work",
    },
    {
      id: 3,
      title: "Premier League 🏆 ",
      
     
      description:
        "Manchester City wins their first Premier League title in dramatic fashion on the final day of the season, snatching it away from arch-rivals Manchester United with a late goal against Queens Park Rangers.Aguerooooo Moment!",
      date: "May 13, 2012",
      icon: "work",
    },
    {
      id: 4,
      title: "Champions League 🏆",
     
      description:
        "Against all odds and with a mere probability of 7% of winnning the intercontinental treble ,City wins the Champions League at Istanbul.",
      date: "July 2023",
      icon: "school",
    },
    
  ];
  
  export default timelineElements;